import { lazy } from "react";

import { Navigate, type RouteObject } from "@cinnamon/design-system/hooks";

import { ROUTE } from "@/constants/route";
import { type RouteSchema } from "@/types/global";

const HomePage = lazy(() => import("./pages/Home"));

export type DemoRouteKey = "HOME";

export const DEMO_ROUTE: Record<DemoRouteKey, RouteSchema> = {
  HOME: {
    to: `/${ROUTE.DEMO.path}/home`,
    path: "home",
  },
};

export const getDemoRoutes = (): RouteObject[] => [
  { path: "", element: <Navigate replace to={DEMO_ROUTE.HOME.to} /> },
  { path: DEMO_ROUTE.HOME.path, element: <HomePage /> },
];
